import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export default function PageTitle({ title, description }) {
  const [pageTitle, setPageTitle] = useState('');
  const location = useLocation();
  
  useEffect(() => {
    const fullTitle = title ? `${title} | Management Capstone` : 'Management Capstone';
    setPageTitle(fullTitle);
    
    // Backup for non-React environment or specific edge cases
    document.title = fullTitle;
  }, [title, location.pathname]);
  
  return (
    <>
      <title>{pageTitle}</title>
      {description && <meta name="description" content={description} />}
    </>
  );
}